<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Edit Operations Audit">

      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>

        <!--Filter header start -->
        <v-row right>
          <v-col cols="12" md="6"></v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" sm="4">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom @click="saveAsDraft" right elevation="1" color="primary"
                    type="button">
                    <v-icon left> mdi-content-save </v-icon>
                    Save as draft
                  </v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right @click="submitAuditV1" elevation="1" color="primary"
                    type="submit">
                    Submit Audit
                  </v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right @click="closeAudit" elevation="1" color="primary"
                    type="button">
                    Close Audit
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete label="Select acadamic year *" disabled v-model="academicYearID"
              :items="acadamicYearData" key="id" item-value="id" item-text="academicYear">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">

            <v-autocomplete label="Select Center" v-model="franchiseeID" disabled
              :items="centreList" key="id" item-value="id" item-text="companyName">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <div class="control audit-date">
              <input class="input" type="date" v-model="auditDate" disabled />
            </div>

          </v-col>

        </v-row>

        <!--Filter header end -->
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card flat class="pb-12">
                <v-card-text>
                  <v-tabs v-model="categoriesTabs" background-color="" center-active>
                    <v-tabs-slider color=""></v-tabs-slider>
                    <v-tab v-for="item in category" :key="item.id">
                      {{ item.categoryName }}
                    </v-tab>
                  </v-tabs>
                  <v-divider class=" my-0"></v-divider>
                  <v-tabs-items v-model="categoriesTabs">
                    <v-tab-item v-for="(item, catIndex) in category" :key="item.id">

                      <v-expansion-panels focusable>
                        <v-expansion-panel v-for="(subcat, subIndex) in item.subCategories"
                          :key="subcat.id">
                          <v-expansion-panel-header>{{ subcat.subCategoryName }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <br />

                            <h5 v-if="subcat.parameters.length === 0">No parameters available</h5>
                            <div v-for="(prm, prmIndex) in subcat.parameters" :key="prm.id">
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <h3 class="v-list-item__title font-weight-regular title">
                                    {{ prm.parameterName }}</h3>
                                </v-col>
                                <v-col col="12" md="6">
                                  <label class="font-weight-medium body-2">
                                    Response Type
                                  </label>
                                  <v-autocomplete key="value"
                                    v-model="category[catIndex].subCategories[subIndex].parameters[prmIndex].responseId"
                                    label="Select Response" :items="responseLists"
                                    @change="onChangeResponse()" item-text="responseType"
                                    item-value="id" required>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="6"
                                  v-if="constant && getResponseTypeById(category[catIndex].subCategories[subIndex].parameters[prmIndex].responseId) === constant.GENERAL_AUDIT.response.no">
                                  <div class="field">

                                    <div>
                                      <label class="font-weight-medium body-2">
                                        No. of Days
                                      </label>

                                      <v-autocomplete key="value" label="Select Days"
                                        :items="numberOptions"
                                        :disabled="category[catIndex].subCategories[subIndex].parameters[prmIndex].isTatDisable"
                                        v-model="category[catIndex].subCategories[subIndex].parameters[prmIndex].tat"
                                        item-text="nText" item-value="value"> </v-autocomplete>
                                    </div>

                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <label class="font-weight-medium body-2">Select File </label>
                                  <span class="has-text-danger">Allowed
                                    files: '.pdf, .png, jpg, jpeg.</span>

                                  <span class="has-text-danger"> Files that are not
                                    supported will be removed automatically!</span>
                                  <v-file-input small-chips v-model="prm.files" multiple
                                    @change="onFilechange(prm.files)" placeholder="Click to Upload"
                                    :messages="['(max file size allowed 100MB)']" accept=".pdf,.png,.jpeg,.jpg"></v-file-input>

                                  <div v-if="prm.files.length > 0">
                                    <v-chip v-for="(file, i) in prm.files" :key="i" color="primary"
                                      label multiple outlined class="ma-2" close
                                      @click:close="deleteDropFile(prm.files, i)">
                                      {{ file.name }}
                                    </v-chip>
                                  </div>
                                  <table class="table is-bordered is-hoverable"
                                    v-if="prm.prevFiles.length > 0">

                                    <tbody>
                                      <tr v-for="(file, i) in prm.prevFiles" :key="i">
                                        <td class="is-flex is-justify-content-space-between">
                                          <a @click="fileOpen(file.filePath)">
                                            {{ file.fileName }}</a>
                                          &nbsp;
                                          &nbsp; &nbsp;
                                          <span class="pl-8">
                                            <v-icon title="Delete"
                                              @click="deleteFile(file.id, catIndex, subIndex, prmIndex, i)">
                                              mdi-delete</v-icon>
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </v-col>
                                <v-col class="pl-0 pr-0" cols="6">

                                  <label class="font-weight-medium body-2">Remarks</label><br />
                                  <v-text-field
                                    v-model="category[catIndex].subCategories[subIndex].parameters[prmIndex].remark "
                                    placeholder="Ex: A" outlined>
                                  </v-text-field>
                                </v-col>
                              </v-row>

                              <hr />
                            </div>
                            <hr role="separator" aria-orientation="horizontal"
                              class="my-0 v-divider theme--light">
                            </hr>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import moment from 'moment'
// import _ from 'lodash'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['auditId'],
  async created () {
    this.constant = constants
    console.log(constants.GENERAL_AUDIT, 'constants.GENERAL_AUDIT')
    await this.getAuditById()
    await this.getAcadamicYearsList()
    await this.getFranchisee()
    this.getResponseList()
    // this.getCategoriesList()

    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      // console.log(val)
      // this.franchiseeID = val.id
    },
    academicYear: async function (val) {
      // console.log(val)
      this.academicYearID = val.id
    }
  },
  data () {
    return {
      franchiseeID: '',
      centreList: [],
      auditDate: '',
      // franchiseeOptions: [],
      constant: null,
      isWrite: true,
      academicYearID: '',
      acadamicYearData: [],
      status: '',
      categoriesTabs: [],
      category: [],
      categoryLists: [],
      categoryTab: [],
      subCategoryLists: [],
      parameterList: [],
      responseLists: [],
      responseType: '',
      responseTypeID: '',
      selectedResponseTypeID: '',
      myDate: null,
      isPublished: '',
      dropFile: null,
      auditDataCopy: [],

      min: 0,
      max: 100,

      numberOptions: [
        { nText: '1', value: 1 },
        { nText: '2', value: 2 },
        { nText: '3', value: 3 },
        { nText: '4', value: 4 },
        { nText: '5', value: 5 },
        { nText: '6', value: 6 },
        { nText: '7', value: 7 },
        { nText: '8', value: 8 },
        { nText: '9', value: 9 },
        { nText: '10', value: 10 },
        { nText: '11', value: 12 },
        { nText: '13', value: 13 },
        { nText: '14', value: 14 },
        { nText: '15', value: 15 }
      ],

      allowedFiles: ['pdf', 'jpg', 'png', 'jpeg'],
      date: new Date().toISOString().substr(0, 7),
      menu: false,

      modal: false,
      formData: {
        academicYearID: '',
        franchiseeID: '',
        auditDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        isPublish: false,
        isActive: true,
        status: ''
      },
      validationErrors: {
        academicYearID: 'Academic Year ID',
        franchiseeID: 'Center',
        auditDate: 'Audit date'
      }
    }
  },
  methods: {
    getResponseTypeById (responseId) {
      let searchIndex = this.responseLists.map(item => item.id).indexOf(responseId)
      let responseType = searchIndex > -1 ? this.responseLists[searchIndex].responseType.toString().toLowerCase() : null
      return responseType
    },
    // Draft Save Method
    getAuditById: async function () {
      try {
        this.isLoading = true
        let rows = await http.get(`${constants.API_URL}/api/audit/auditbyid/${this.auditId}`)
        this.auditData = rows.data
        this.academicYearID = this.auditData.academicYearID
        this.franchiseeID = this.auditData.franchiseeID
        this.auditDate = this.auditData.auditDate
        this.category = this.auditData.auditCategoryMaps.map(item => {
          let mainCategory = {
            auditCategoryID: item.category.id,
            categoryName: item.category.categoryName,
            // categoryScore: item.categoryScore,
            overallRemark: '',
            subCategories: []
          }

          mainCategory.subCategories = item.subCategories.map(sub => {
            let subCategory = {
              subCategoryID: sub.auditSubCategoryID,
              subCategoryName: sub.subcategoryName,
              id: sub.id
            }
            subCategory.parameters = sub.parameters.map(prm => {
              let tat = 0
              if (prm.tat) {
                tat = moment(prm.tat).format('YYYY-MM-DD')
                let createdAt = moment(prm.createdAt).format('YYYY-MM-DD')
                tat = Math.abs(moment(createdAt).diff(tat, 'days'))
              }

              return {
                parameterID: prm.id,
                auditParameterID: prm.auditParameterID,
                parameterName: prm.parameterName,
                status: prm.status,
                parameterScore: prm.parameterScore,
                files: [],
                prevFiles: prm.files,
                remark: prm.remark,
                responseId: prm.responseId,
                tat: tat,
                isTatDisable: tat > 0
              }
            })
            return subCategory
          })
          return mainCategory
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    async saveParameterFiles (newfilesList, auditSubCategoryMapID) {
      try {
        // console.log(newfilesList, 'New Files Item')
        this.isLoading = true
        let formData = new FormData()
        for (let i = 0; i < newfilesList.length; i++) {
          formData.append('files', newfilesList[i])
        }
        // console.log(formData, 'files')
        formData.append('auditSubCategoryMapID', auditSubCategoryMapID)

        let res = await http.post(`${constants.API_URL}/api/audit/add-audit-files`, formData)
        return res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return errorMessage
      } finally {
        this.isLoading = false
      }
    },

    onFilechange (files) {
      // console.log(files, 'file new list')
      let r = files.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.files = r
    },
    deleteDropFile (files, i) {
      files.splice(i, 1)
    },

    getResponseList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/audit/audit-response/getall`)
        this.responseLists = data
        this.responseType = this.responseLists.responseType
        this.responseTypeID = this.responseLists.id
        this.isLoading = false
        return this.responseList
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    saveAsDraft: async function () {
      let parameters = []
      try {
        for (let category of this.category) {
          for (let subCat of category.subCategories) {
            for (let prm of subCat.parameters) {
              if (prm.files.length > 0) {
                await this.saveParameterFiles(prm.files, prm.parameterID)
              }
              parameters.push({
                // auditParameterID: prm.auditParameterID,
                id: prm.parameterID,
                responseId: prm.responseId,
                tat: prm.tat,
                remark: prm.remark,
                status: prm.status
              })
            }
          }
        }
        let payload = {
          overallRemark: '',
          isPublish: false,
          status: 'IN-PROGRESS',
          parameters: parameters
        }
        const { data } = await http.put(`${constants.API_URL}/api/audit/updateaudit/${this.auditId}`, payload)
        console.log(data, 'data')
        this.okMsg('Audit saved in draft successfully!!')
        this.$router.push({ name: 'generalAuditDraftList' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee`)
        this.centreList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getAcadamicYearsList: async function () {
      let rows = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`, {
        params: {
          isCurrentAcademicYear: true
        }
      })
      this.acadamicYearData = rows.data.rows
    },
    fileOpen: async function (filePath) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${filePath}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteFile: async function (id, catIndex, subIndex, prmIndex, i) {
      // console.log(arr, 'files')
      this.$dialog.error({
        title: 'Delete File ?',
        text: 'Do you want to delete this file?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                let fileDeleteList = {
                  id: id,
                  isActive: false
                }

                await http.put(`${constants.API_URL}/api/audit/delete-file/${this.auditId}`, fileDeleteList)
                this.category[catIndex].subCategories[subIndex].parameters[prmIndex].prevFiles.splice(i, 1)
                this.okMsg('File deleted successfully!')
                this.$forceUpdate()
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    submitAuditV1: async function () {
      try {
        let parameters = []
        if (this.submitValidation(this.category)) {
          console.log(this.category, 'Ctaegories1')
          for (let category of this.category) {
            for (let subCat of category.subCategories) {
              for (let prm of subCat.parameters) {
                if (prm.files.length > 0) {
                  await this.saveParameterFiles(prm.files, prm.parameterID)
                }
                parameters.push({
                  // auditParameterID: prm.auditParameterID,
                  id: prm.parameterID,
                  responseId: prm.responseId,
                  tat: '',
                  remark: prm.remark,
                  status: prm.status
                })
              }
            }
          }
          let payload = {
            overallRemark: '',
            isPublish: true,
            status: 'COMPLETED',
            parameters: parameters
          }

          const { data } = await http.put(`${constants.API_URL}/api/audit/updateaudit/${this.auditId}`, payload)
          console.log(data, 'Submitted Dta')
          this.okMsg('Audit submitted successfully!!')
          this.$router.push({ name: 'generalAudits' })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    submitValidation (categories) {
      let message = ''
      for (let c of categories) {
        for (let s of c.subCategories) {
          for (let p of s.parameters) {
            if (!p.responseId) {
              this.errMsg('Complete reponse to submit the audit.')
              return false
            }
            let responseType = this.getResponseTypeById(p.responseId)
            if (responseType === this.constant.GENERAL_AUDIT.response.no && !p.tat) {
              this.errMsg('Please select number of days')
              return false
            } else if (responseType === this.constant.GENERAL_AUDIT.response.no && p.tat) {
              this.errMsg('Please complete all audit parameters or wait till number of days are complete.')
              return false
            }
          }
        }
      }
      if (message !== '') {
        this.$buefy.toast.open({
          message: message,
          type: 'is-danger',
          duration: 4000
        })
      }
      return message === ''
    },
    // close edit
    closeAudit: async function () {
      try {
        let parameters = []
        if (this.closeValidation(this.category)) {
          console.log(this.category, 'Close category')
          for (let category of this.category) {
            for (let subCat of category.subCategories) {
              for (let prm of subCat.parameters) {
                if (prm.files.length > 0) {
                  await this.saveParameterFiles(prm.files, prm.parameterID)
                }
                parameters.push({
                  // auditParameterID: prm.auditParameterID,
                  id: prm.parameterID,
                  responseId: prm.responseId,
                  tat: '',
                  remark: prm.remark,
                  status: prm.status
                })
              }
            }
          }
          let payload = {
            overallRemark: '',
            // isPublish: isPublish,
            isPublish: false,
            status: 'CLOSED',
            parameters: parameters
          }

          const { data } = await http.put(`${constants.API_URL}/api/audit/updateaudit/${this.auditId}`, payload)
          console.log(data, 'Submitted Dta')
          this.okMsg('Audit closed successfully!!')
          this.$router.push({ name: 'auditClosures' })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },

    closeValidation (categories) {
      let message = ''
      for (let c of categories) {
        for (let s of c.subCategories) {
          for (let p of s.parameters) {
            if (!p.responseId) {
              this.errMsg('Complete reponse to submit the audit.')
              return false
            }
            let responseType = this.getResponseTypeById(p.responseId)
            if (responseType === this.constant.GENERAL_AUDIT.response.no && !p.tat) {
              this.errMsg('Please select number of days')
              return false
            } else if (responseType === this.constant.GENERAL_AUDIT.response.no && p.tat) {
              this.errMsg('Please complete all audit parameters or wait till number of days are complete.')
              return false
            }
          }
        }
      }
      if (message !== '') {
        this.$buefy.toast.open({
          message: message,
          type: 'is-danger',
          duration: 4000
        })
      }
      return message === ''
    },
    // closeAuditPrompt () {
    //   this.$dialog.error({
    //     title: 'Audit ?',
    //     text: 'Do you want to publish the audit?',
    //     actions: {
    //       false: {
    //         text: 'No',
    //         handle: async () => {
    //           this.closeAudit(false)
    //           this.okMsg('Audit closed successfully!!')
    //           this.$router.push({ name: 'auditClosures' })
    //         }
    //       },
    //       true: {
    //         color: 'success',
    //         text: 'Yes',
    //         handle: async () => {
    //           this.closeAudit(true)
    //           this.okMsg('Audit published successfully!!')
    //           this.$router.push({ name: 'generalAudits' })
    //         }
    //       }
    //     }
    //   })
    // },
    //
    onChangeResponse () {
      this.$forceUpdate()
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    // End of Save Methods
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>

<style scoped>
.add-audit-offline {
  position: absolute;
  right: 150px;
  top: 18px;
}
.add-audit-online {
  position: absolute;
  right: 180px;
  top: 0;
}
.audit-date {
  padding-top: 10px;
}
</style>
